import { render, staticRenderFns } from "./MultiSelectChips.vue?vue&type=template&id=95b972da&scoped=true&"
import script from "./MultiSelectChips.vue?vue&type=script&lang=js&"
export * from "./MultiSelectChips.vue?vue&type=script&lang=js&"
import style0 from "./MultiSelectChips.vue?vue&type=style&index=0&id=95b972da&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b972da",
  null
  
)

export default component.exports